module.exports = __webpack_public_path__ + "static/media/dashboard_light.586713a1.svg";